export { default as RisksComparison } from "./risks_comparison"


// WEBPACK FOOTER //
// ./src/views/risks_comparison/index.js